module.exports = __webpack_public_path__ + "img/strategy_contract_grey.e2024acb.svg";